(function ($, root, undefined) {
	$(function () {
		$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
			&& 
			location.hostname == this.hostname
			) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
				scrollTop: target.offset().top - 140
				}, 1000, function() {
				// Callback after animation
				// Must change focus!
				var $target = $(target);
				$target.focus();
				if ($target.is(":focus")) { // Checking if the target was focused
					return false;
				} else {
					$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					$target.focus(); // Set focus again
				};
				});
			}
			}
		});
        $(window).scroll(function() {    
			var scroll = $(window).scrollTop();    
			if (scroll >= 50) {
				$(".header-wrapper").addClass("darkHeader");
			}else{
				$(".header-wrapper").removeClass("darkHeader");
			}
		});
         $(".bannerSlider").slick({
            infinite: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			draggable: false,
            dots:false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						adaptiveHeight:true,
					}
				}
				
			]
        })
        $(".featuredSlider").slick({ 
            infinite: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
            // dots:true,
            // appendDots:".dots",
			prevArrow: $(this).find(".prevF"),
			nextArrow: $(this).find(".nextF"),

			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						adaptiveHeight:true,

					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						adaptiveHeight:true,

					}
				}
				
			]
        })
        $(".prodSlider").slick({
            infinite: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
            // dots:true,
            // appendDots:".dots",
			prevArrow: $(this).find(".prevFe"),
			nextArrow: $(this).find(".nextFe"),
        })
        $(".infiniteSlider").slick({
			slidesToShow: 10,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
  			autoplaySpeed: 100,
			speed: 2000,
			arrows: false,
			variableWidth: true,
			arrows: false,
			cssEase: 'linear',
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 8,
					}
				},				
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 6,
					}
				},				
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 4,
					}
				},				
			]
        })
        $(".promSlider").slick({
            infinite: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
            // dots:true,
            // appendDots:".dots",
			prevArrow: $(this).find(".prevProm"),
			nextArrow: $(this).find(".nextProm"),

			responsive: [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						adaptiveHeight:true,

					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						adaptiveHeight:true,

					}
				}
				
			]
        })
		$(".colProdSlider").each(function(){
			var slider = $(this).find(".prodsBox");
			slider.slick({
				infinite: true,
				autoplay: true,
				  autoplaySpeed: 5000,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				// dots:true,
				// appendDots:".dots",
				prevArrow: $(this).find(".prevF"),
				nextArrow: $(this).find(".nextF"),
	
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							adaptiveHeight:true,
	
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							adaptiveHeight:true,
	
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							adaptiveHeight:true,
	
						}
					}
				]
			})
		})
		$(".colFour").each(function(){
			var slider = $(this).find(".prodsBox");
			slider.slick({
				infinite: true,
				autoplay: true,
				  autoplaySpeed: 5000,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: $(this).find(".prevF"),
				nextArrow: $(this).find(".nextF"),
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							adaptiveHeight:true,
	
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							adaptiveHeight:true,
	
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							adaptiveHeight:true,
	
						}
					}
				]
			})
		});
		$(".colThree").each(function(){
			var slider = $(this).find(".prodsBox");
			slider.slick({
				infinite: true,
				autoplay: true,
				  autoplaySpeed: 5000,
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: $(this).find(".prevF"),
				nextArrow: $(this).find(".nextF"),
				responsive: [
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1,
							adaptiveHeight:true,
	
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
							adaptiveHeight:true,
	
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							adaptiveHeight:true,
	
						}
					}
				]
			})
		});

        $(document).on("click", ".js-load-more-product-collection", function () {
			var $this = $(this);
			var nextUrl = $("[data-next-url]").val();

			if (!nextUrl) {
			console.log("No next URL found, stopping load more.");
			$(".load-more_wrap").hide();
			return;
			}

			$this.prop("disabled", true).text("Loading...");

			$.ajax({
			url: nextUrl,
			type: "GET",
			dataType: "html",
			success: function (responseHTML) {
				var $response = $(responseHTML);

				// Append new products
				$(".product-grid").append($response.find(".product-grid").html());

				// Update the next URL
				var updatedNextUrl = $response.find("[data-next-url]").val();
				if (updatedNextUrl) {
				$("[data-next-url]").val(updatedNextUrl);
				$this.prop("disabled", false).text("Load More Products");
				} else {
				$(".load-more_wrap").hide();
				}

				// Save updated state in sessionStorage
				sessionStorage.setItem("collectionHtml", $(".product-grid").html());
				var prev_collectionNextUrl = sessionStorage.getItem("collectionNextUrl");
				if(updatedNextUrl){
				// sessionStorage.setItem("collectionNextUrl", updatedNextUrl || "");
				sessionStorage.setItem("collectionNextUrl", updatedNextUrl);
				sessionStorage.setItem("removeLoaMoreBtn", "false");
				}else{
				sessionStorage.setItem("collectionNextUrl", prev_collectionNextUrl);
				sessionStorage.setItem("removeLoaMoreBtn", "true");
				}
				sessionStorage.setItem("collectionScroll", $(window).scrollTop());
				sessionStorage.setItem("collectionUrl", window.location.pathname); // current collection
			},
			error: function () {
				console.error("Failed to load next page.");
				$this.prop("disabled", false).text("Load More");
			},
			});
		});

		$(document).on("click", "a", function (e) {
			const href = $(this).attr("href");

			if (!href) return; // skip if no href

			// Only act if it's a relative internal link
			if (href.startsWith("/") && !href.includes("/products/")) {
			// You can extend this logic if needed
			if (
				href.includes("/collections/") ||
				href.includes("/page/") ||
				href.includes("/blogs/") || // add more allowed paths if needed
				href.includes("/search")
			) {
				console.log("Removing removeLoaMoreBtn due to anchor click:", href);
				sessionStorage.removeItem("removeLoaMoreBtn");
			}
			}
		});
		//removing load more button if session variable is true
		if (sessionStorage.getItem("removeLoaMoreBtn") === "true") {
			$(".load-more_wrap").remove();
		}

        function getCollectionHandleFromPath(path) {
			const match = path.match(/^\/collections\/([^\/\?]+)/);
			return match ? match[1] : null;
		}

		const currentPath = window.location.pathname;
		const currentCollectionHandle = getCollectionHandleFromPath(currentPath);
		const isCollectionPage = currentPath.includes("/collections/");

		// 🔁 Clear sessionStorage on hard visit BEFORE anything else
		const navEntry = performance.getEntriesByType("navigation")[0];
		const isFreshVisit = navEntry && navEntry.type === "navigate";

		if (isCollectionPage && isFreshVisit) {
			console.log("sessionStorage cleared (fresh collection visit)");
			sessionStorage.removeItem("collectionHtml");
			sessionStorage.removeItem("collectionNextUrl");
			sessionStorage.removeItem("collectionScroll");
			sessionStorage.removeItem("collectionUrl");
			sessionStorage.removeItem("collectionHandle");
		}

		// 🔁 Now get previously stored handle
		const savedHandle = sessionStorage.getItem("collectionHandle");
		const savedHtml = sessionStorage.getItem("collectionHtml");
		const savedNextUrl = sessionStorage.getItem("collectionNextUrl");
		const savedScroll = parseInt(sessionStorage.getItem("collectionScroll"), 10) || 0;

		// 🧹 Clear if handle changed (should be BEFORE restore)
		if (
			savedHandle &&
			currentCollectionHandle &&
			savedHandle !== currentCollectionHandle
		) {
			sessionStorage.removeItem("collectionHtml");
			sessionStorage.removeItem("collectionNextUrl");
			sessionStorage.removeItem("collectionScroll");
			sessionStorage.removeItem("collectionUrl");
			sessionStorage.removeItem("collectionHandle");
			console.log("collection handle changed — storage cleared");
		}

		// ✅ Only restore AFTER checking everything (not earlier)
		if (
			savedHtml &&
			savedNextUrl &&
			savedHandle &&
			currentCollectionHandle &&
			savedHandle === currentCollectionHandle
		) {
			console.log("url match");
			$(".product-grid").html(savedHtml);
			$("[data-next-url]").val(savedNextUrl);
			var storedProductId = localStorage.getItem('currentPrdScrollID');
			setTimeout(() => {
			// window.scrollTo({ top: savedScroll, behavior: "auto" });
			if (storedProductId) {
				var $storedProduct = $('#' + storedProductId);
				if ($storedProduct.length) {
					// $('html, body').animate({
					//     scrollTop: $storedProduct.offset().top - ($(window).height() * 0.25)
					// }, 800);
					window.scrollTo({
						top: $storedProduct.offset().top - ($(window).height() * 0.25),
						behavior: 'auto' // No animation
					});
					console.log("Scrolled to:", $storedProduct);
					console.log("Scrolled id:", storedProductId);
				}else{
					// $('html, body').animate({
					//     scrollTop: $productGrid.offset().top - ($(window).height() * 0.25)
					// }, 800);
					window.scrollTo({
						top: $productGrid.offset().top + ($productGrid.height() * 0.95),
						behavior: 'auto' // No animation
					});
					console.log("Not Scrolled to:", $storedProduct);
					console.log("Not Scrolled id:", storedProductId);
				}
				console.log("scrolllllled: ", $storedProduct);
			}else{
				var $productGrid = $('.product-grid');
				// $('html, body').animate({
				//     scrollTop: $productGrid.offset().top + ($productGrid.height() * 0.95)
				// }, 700);
				window.scrollTo({
					top: $productGrid.offset().top + ($productGrid.height() * 0.95),
					behavior: 'auto' // No animation
				});
			}
			}, 100);
		} else {
			console.log("no url match or different collection");
			console.log("savedHandle:", savedHandle);
			console.log("currentCollectionHandle:", currentCollectionHandle);
		}

		// ✅ Now — AFTER all logic — save current path & handle
		if (isCollectionPage && currentCollectionHandle) {
			sessionStorage.setItem("collectionHandle", currentCollectionHandle);
			sessionStorage.setItem("collectionUrl", currentPath);
			console.log("collection url included");
		}
		$(document).on("click", ".scroll_id_save_click", function () {
			// $('.scroll_id_save_click').on('click', function() {
			if (window.location.pathname.includes("/collections/")) {
			var scroll_id = $(this).attr("data-scroll-id");
			console.log("cliekc product");
			localStorage.setItem("currentPrdScrollID", scroll_id);
			}
		});

		if(!window.location.pathname.includes("/collections/") && !window.location.pathname.includes("/products/")){
			localStorage.removeItem("currentPrdScrollID");
		}


		const formContainer = document.querySelector('.form.custom_styling');

		if (formContainer) {
			const observer = new MutationObserver((mutationsList, observer) => {
			// const form = formContainer.querySelector('form-embed');
			const form = formContainer.querySelector('shopify-forms-embed');
			
			if (form) {
				console.log("rwesss");
				observer.disconnect(); // Stop observing once the form is found
				const shadow = form.shadowRoot;

				const sheet = new CSSStyleSheet();
				sheet.insertRule(`
					#form-container-ref section{
                        max-width:100%;
                    }
				`);
				sheet.insertRule(`
					._inline_1q1d2_47 ._formContainer_1q1d2_30{
                        max-width:100%;
                    }
				`);

				sheet.insertRule(`          
                    form {
                      display: grid !important;
                      grid-template-columns: 1fr 1fr !important; /* Two equal columns */
                      grid-template-rows: auto !important; /* Automatically adjust row height */
                    }
                `);

				sheet.insertRule(`          
                    form > div:nth-child(2) {
                        grid-area: first-name !important;
                    }
                `);
				sheet.insertRule(`          
                    form > div:nth-child(3) {
                        grid-area: last-name !important;
                    }
                `);
				sheet.insertRule(`          
                    form > div:nth-child(4) {
                        grid-area: email !important;
                    }
                `);
				sheet.insertRule(`          
                    form > div:nth-child(5) {
                        grid-area: phone-area !important;
						align-items:flex-end;
                    }
                `);
				sheet.insertRule(`          
                    form > div:nth-child(6) {
                        grid-area: reason !important;
                    }
                `);
				sheet.insertRule(`          
                    form > div:nth-child(7) p {
						font-family: "indivisible", sans-serif !important;
						font-weight: 400 !important;
						font-style: normal !important;
						color: #000000 !important; 
						opacity: 1 !important;
						font-size: 16px;
						text-transform: capitalize !important;
                    }
                `);
				sheet.insertRule(`          
                    form > div:nth-child(7) {
                        grid-area: msg !important;
                    }
                `);
				sheet.insertRule(`
					input, textarea, button[type="button"] {
                        border-radius: 0px !important;
                        font-family: "indivisible", sans-serif !important;
                        font-style: normal !important;
                        font-size: 16px !important;
                        padding:15px 0 !important;
                        color: black !important; 
                        background-color:transparent !important;
                        border-bottom: 2px solid #cdcdcd !important; 
                        box-shadow: none !important;
					}
				`);
				
                if (window.innerWidth <= 510) {
                    sheet.insertRule(`
                      form {
                        gap: 16px !important; /* Space between grid items */
                        grid-template-areas:
                          "first-name first-name"
                          "last-name last-name"
                          "email email"
                          "phone-area phone-area"
                          "reason reason"
                          "msg msg"
                          "submit submit" !important;
                      }
                    `);
                }else{
                    sheet.insertRule(`
                      form {
                        gap: 16px !important; /* Space between grid items */
                        grid-template-areas:
                          "first-name last-name"
                          "email phone-area"
                          "reason reason"
                          "msg msg"
                          "submit submit" !important;
                      }
                    `);
					sheet.insertRule(`            
						button[type='submit'] {
							grid-column: span 2;
							margin-top:0 !important;
						}            
					`);     
                  }
                sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                      font-family: "indivisible", sans-serif !important;
                      font-weight: 400 !important;
                      font-style: normal !important;
                      color: #000000 !important; 
                      opacity: 1 !important;
                      text-transform: capitalize !important;
                    }
                  `);
				sheet.insertRule(`
					label {
                        font-family: "indivisible", sans-serif !important;
                        font-style: normal !important;
                        left:0 !important;
                        font-size: 16px !important;
                        color: black !important; 
                        opacity: 1 !important;
                        display:none !important;
					}
				`);
                //submit button styling
                sheet.insertRule(`            
                    button[type='submit'] {
                        font-family: "indivisible", sans-serif !important;
                        font-style: normal !important;
                        text-transform: uppercase !important;
                        color: #000000 !important;
                        background: transparent !important;
                        transition: all .3s ease-in-out .01s !important;
                        font-size: 15px !important;
                        border-radius: 0px !important;
                        text-align: center !important;
                        font-weight:500 !important;
                        padding:15px 40px !important;
                        margin-top:20px!important;
                        width: fit-content !important;
                        border: 1px solid #000000 !important; 
                    }            
                `);        
				
				// Add placeholders to inputs
				  // @ts-ignore
                const inputs = shadow.querySelectorAll('input, textarea');
                inputs.forEach((input) => {
					
				    switch (input.id) {
				      case 'first_name':
				        // @ts-ignore
				        input.placeholder = 'first name';
				        break;
				      case 'last_name':
				        // @ts-ignore
				        input.placeholder = 'last name';
				        break;
				      case 'email':
				        // @ts-ignore
				        input.placeholder = 'email address';
				        break;
				      case 'custom#country':
				        // @ts-ignore
				        input.placeholder = 'Country';
				        break;
				      case 'custom#province':
				        // @ts-ignore
				        input.placeholder = 'Province';
				        break;
				      case 'custom#message':
				        // @ts-ignore
				        textarea.placeholder = 'message';
				        break;
				      default:
				        break;
				    }
                });

				  // Apply the styles to the Shadow DOM
				  // @ts-ignore
                shadow.adoptedStyleSheets.push(sheet);                
				// Add a class to the form container for further customization
				formContainer.classList.add('loaded');
			}
		});

		// Observe for changes only within the custom section
		observer.observe(formContainer, { childList: true, subtree: true });

            // Resize event listener to act like media query
            window.addEventListener('resize', () => {
                // Trigger MutationObserver actions based on screen size
                observer.takeRecords(); // Forces MutationObserver to re-evaluate
            });
		}

		if($("cart-items").hasClass("is-empty")){
			$(".cartCols").addClass("emptyCart");
		}
    });
// @ts-ignore
})(jQuery, this);